import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as MaterialCategoryId } from '../../../../whole-house/material-category/Id';
import { Id as MaterialTemplateId } from '../../../../whole-house/material-template/Id';
import { PriceUnitItem } from '../../../../whole-house/material/price-unit';
import { Id as PropertyType, PropertyItem } from '../../../../whole-house/material/property-type';
import { Id as StockStatus } from '../../../../whole-house/material/stock-status';

export const Request = intersect(
	struct({
		name: iotsUtils.NotEmptyString,
		organizationId: OrganizationId,
		sku: iotsUtils.NotEmptyString,
		priceUnit: PriceUnitItem,
		stockStatus: StockStatus,
		propertyTypes: array(PropertyType),
		// if propertyType has value then those proerties in propertyValues are required
		propertyValues: PropertyItem,
	})
)(
	partial({
		materialCategoryId: MaterialCategoryId,
		newCategory: string,
		materialTemplateId: MaterialTemplateId,
	})
);
/**
 * Sample JSON:
 * {
		"name": "Material A",
		"organizationId": "organization:5f7b1b1b-7b1b-4b1b-8b1b-7b1b1b1b1b1b",
		"sku": "SKU123",
		"priceUnit": {
			"priceUnit": "each",
			"packQty": 1,
			"min": 1,
			"inc": 1
		},
		"wastage": 0.1,
		"status": "stocking",
		"usageDetailsList": [
			{
				"usageId": "usage:c39992e8-22df-4bc5-8605-b49b19eaa0e8",
				"measurement": {
					"measurementType": "each",
					"quantity": 1
				}
			}
		]
	}
 */
